import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import { FlexRow, FlexCol } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { Title } from '../General/Text';
import { TextP } from '../../Defaults/Text';
import { Status } from './Status';
import { IconType } from '../General/SvgIcon';

export enum RequestStatus {
  DONE = 'DONE',
  INWORK = 'INWORK',
  WAITING = 'WAITING',
}

interface Props {
  title: string;
  smallText: string;
  note: string;
  status: RequestStatus;
  statusText: string;
  theme: any;
}

function RequestTitle({
  title,
  smallText,
  status,
  statusText,
  note,
  theme,
}: Props) {
  const loadInfoBasedOnStatus = () => {
    switch (status) {
      case RequestStatus.DONE: {
        return {
          color: theme.colors.success,
          icon: IconType.paid,
        };
      }
      case RequestStatus.INWORK: {
        return { color: theme.colors.primary, icon: IconType.inwork };
      }
      case RequestStatus.WAITING: {
        return { color: theme.colors.placeholder, icon: IconType.time };
      }
      default: {
        return { color: theme.colors.placeholder, icon: IconType.time };
      }
    }
  };

  const { icon, color } = loadInfoBasedOnStatus();

  return (
    <Wrapper>
      <LeftSide>
        <StyledTitle marginTop={0} marginBottom={16}>
          {title}
        </StyledTitle>
        {smallText && <SmallText>{smallText}</SmallText>}
        {note && (
          <>
            <br />
            <SmallText>
              <NoteText>{__('Poznámka')}</NoteText>
              {`: ${note}`}
            </SmallText>
          </>
        )}
      </LeftSide>
      <Status color={color} text={statusText} icon={icon} />
    </Wrapper>
  );
}

const Wrapper = styled(FlexRow)`
  flex-flow: row wrap;
  margin-bottom: ${rem(16)};
  justify-content: space-between;

  ${({ theme }) => theme.mediab.m810`
    margin: 0;
  `};
`;

const LeftSide = styled(FlexCol)``;

const SmallText = styled(TextP)`
  font-family: ${({ theme }) => theme.font.secondaryLight};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.placeholder};
  font-size: ${rem(14)};
  line-height: ${rem(22)};
`;

const NoteText = styled.span`
  font-family: ${({ theme }) => theme.font.secondaryLight};
  font-weight: 400;
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.black};
`;

const StyledTitle = styled(Title)`
  font-family: ${({ theme }) => theme.font.primary};
`;

const WithTheme: any = withTheme(RequestTitle);
export { WithTheme as RequestTitle };
